import { Heart, Sparkles, Users } from "lucide-react";
import useScrollReveal from "@/hooks/useScrollReveal";

const AboutSection = () => {
  const sectionRef = useScrollReveal();

  return (
    <section id="about" data-testid="about-section" className="section-padding bg-white relative overflow-hidden" ref={sectionRef}>
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-emerald-50/50 to-transparent" />

      <div className="container-custom relative">
        <div className="grid lg:grid-cols-12 gap-16 lg:gap-20 items-center">
          {/* Image */}
          <div className="lg:col-span-5 order-2 lg:order-1 reveal">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-emerald-100 to-emerald-50 rounded-[2rem] transform rotate-2" />
              <img
                src="https://customer-assets.emergentagent.com/job_thermomix-zuhause/artifacts/r6wncb9n_cbb0b5ed-96ce-4e2f-9ad2-523d25a84699.jpeg"
                alt="Jennifer Laak - Thermomix Repräsentantin Krefeld - Persönliche Beratung"
                data-testid="about-image"
                className="relative rounded-[2rem] w-full aspect-[4/5] object-cover shadow-2xl"
              />
              <div className="absolute -bottom-4 -right-4 glass-strong rounded-2xl p-4 shadow-xl">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-emerald-500 flex items-center justify-center">
                    <Heart className="w-5 h-5 text-white" fill="white" />
                  </div>
                  <div>
                    <div className="text-sm font-bold text-slate-900">500+</div>
                    <div className="text-xs text-slate-500">Kunden in Krefeld</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Content - FULL text from reference */}
          <div className="lg:col-span-7 order-1 lg:order-2">
            <div className="reveal">
              <span className="inline-block text-xs font-bold uppercase tracking-[0.2em] text-emerald-600 mb-4 italic">
                Vertrauen & Kompetenz
              </span>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 tracking-tight mb-8 font-[Outfit]">
                Jennifer Laak: Deine Krefelder Genuss-Botschafterin
              </h2>
            </div>

            <div className="space-y-6 text-slate-600 text-base md:text-lg leading-relaxed mb-10 reveal reveal-delay-1">
              <p>
                Willkommen in meiner kulinarischen Welt! Ich bin Jennifer Laak, und als offizielle 
                Thermomix® Repräsentantin in Krefeld brenne ich dafür, modernen Haushalten den 
                Alltag zu erleichtern. Kochen ist für mich viel mehr als nur die Zubereitung von 
                Nahrung – es ist Lebensqualität, Kreativität und wertvolle Zeit mit der Familie. 
                In Krefeld und dem gesamten Umkreis von 25 Kilometern bin ich deine erste 
                Ansprechpartnerin, wenn es um das Multitalent von Vorwerk geht.
              </p>
              <p>
                Warum entscheiden sich so viele Menschen in Krefeld, Willich oder Meerbusch für 
                eine Beratung bei mir? Weil ich den Unterschied mache. Ein Gerät im Internet zu 
                bestellen ist einfach, aber einen Thermomix® wirklich in das eigene Leben zu 
                integrieren, erfordert Begleitung. Ich stehe für eine ehrliche, nahbare und fachlich 
                fundierte Beratung. <strong className="text-slate-800">Mein Ziel ist es nicht, dir einfach nur ein Gerät zu 
                verkaufen, sondern sicherzustellen, dass du jeden Tag mit Freude und Erfolg kochst.</strong>
              </p>
              <p>
                Als deine lokale Expertin kenne ich die Bedürfnisse meiner Kunden genau. Ob du als 
                berufstätige Mutter in Kempen Zeit sparen willst, als gesundheitsbewusster Single in 
                Moers auf frische Zutaten setzt oder als leidenschaftlicher Hobbykoch in Viersen neue 
                Techniken wie Sous-vide oder Fermentieren entdecken möchtest – ich hole dich genau dort 
                ab, wo du stehst. Meine Arbeit endet nicht mit der Unterschrift; sie beginnt dort erst 
                richtig. Ich begleite dich beim Unboxing, bei den ersten Rezepten und bin auch Monate 
                später noch für deine Fragen erreichbar.
              </p>
            </div>

            <div className="flex gap-8 mb-10 reveal reveal-delay-2">
              {[
                { val: "500+", label: "Kunden in Krefeld" },
                { val: "100%", label: "Leidenschaft" },
                { val: "24/7", label: "Support-Herz" }
              ].map((s, i) => (
                <div key={i} className="flex flex-col">
                  <span className="text-2xl font-extrabold text-slate-900">{s.val}</span>
                  <span className="text-[10px] uppercase font-bold text-slate-400 tracking-widest">{s.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
